import React, { useState, useEffect } from "react";
import { LoginForm } from "./LoginForm";
import { RegisterForm } from "./RegisterForm";
import { ForgotPasswordForm } from "./ForgotPasswordForm";
import { ResetPasswordForm } from "./ResetPasswordForm";

export const AuthPage = () => {
  const [view, setView] = useState("login"); // login, register, forgot, reset
  const [resetToken, setResetToken] = useState(null);

  // Check for reset token in URL on mount
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token && window.location.pathname.includes("reset-password")) {
      setResetToken(token);
      setView("reset");
    }
  }, []);

  const goToLogin = () => {
    // Clear URL params when going back to login
    window.history.replaceState({}, "", window.location.pathname.split("?")[0]);
    setResetToken(null);
    setView("login");
  };

  switch (view) {
    case "register":
      return <RegisterForm onSwitchToLogin={goToLogin} />;
    case "forgot":
      return <ForgotPasswordForm onSwitchToLogin={goToLogin} />;
    case "reset":
      return <ResetPasswordForm token={resetToken} onSwitchToLogin={goToLogin} />;
    default:
      return (
        <LoginForm 
          onSwitchToRegister={() => setView("register")} 
          onSwitchToForgotPassword={() => setView("forgot")}
        />
      );
  }
};
